import { TextField } from '@mui/material'
import { useEffect, useState } from 'react'

interface Props {
  id: string
  defaultValue: string
  onSave: (value: string) => void
}

export default function SingleChangeFormComponent(props: Props) {
  const [value, setValue] = useState(props.defaultValue)

  useEffect(() => {
    setValue(props.defaultValue)
  }, [props.defaultValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }

  const handleOutFocus = () => {
    props.onSave(value)
  }

  return (
    <TextField
      id={props.id}
      value={value}
      onChange={handleChange}
      onBlur={handleOutFocus}
    />
  )
}
